export default {"src":"/_next/static/media/qualifying-item-badge-2.7889d538.svg","height":152,"width":152,"blurWidth":0,"blurHeight":0};